module.exports = __webpack_public_path__ + "static/media/bg-music-fields.19de4679.jpg";